<div class="occ-public-page">
  <div class="container py-5" style="max-width: 760px;">
    <div class="text-center mb-4">
      <span class="brand-badge">🛡️</span>
      <h1 class="h2 mt-3 mb-1">Registar ocorrência</h1>
      <p class="text-muted mb-0">
        Participações, reclamações, sugestões e denúncias — de forma anónima ou identificada.
        <br />Já registou? <a [routerLink]="['/', tenant, 'acompanhar']">Acompanhar o estado</a>.
      </p>
    </div>

    @if (trackingCode(); as code) {
      <!-- Sucesso: o código de acompanhamento é a única chave do participante -->
      <div class="card">
        <div class="card-body text-center py-5">
          <span class="h1 d-block mb-2">✅</span>
          <h2 class="h3 mb-2">Participação registada</h2>
          <p class="text-muted">A sua ocorrência ficou <strong>registada</strong>. Guarde o código de acompanhamento —
            é a única forma de consultar o estado sem se identificar.</p>
          <div class="occ-tracking-code my-4">{{ code }}</div>
          <div class="d-flex justify-content-center gap-2">
            <button class="btn btn-white" (click)="copyCode()">
              <i class="fe fe-copy me-1"></i> {{ copied() ? 'Copiado!' : 'Copiar código' }}
            </button>
            <a class="btn btn-primary" [routerLink]="['/', tenant, 'acompanhar']" [queryParams]="{ codigo: code }">
              Acompanhar estado
            </a>
          </div>
        </div>
      </div>
    } @else if (!reason()) {
      <!-- Passo 1: escolher em linguagem comum. A tradução para o catálogo é interna. -->
      <div class="card">
        <div class="card-body">
          <h2 class="h4 mb-1">O que quer comunicar?</h2>
          <p class="text-muted small mb-4">Escolha a opção mais próxima — a equipa afina a classificação depois.</p>
          <div class="row g-3">
            @for (r of reasons; track r.id) {
              <div class="col-12 col-md-6">
                <button type="button" class="occ-reason w-100 text-start" (click)="selectReason(r)">
                  <span class="occ-reason-icon" [class.occ-reason-icon--sensitive]="r.sensitive">
                    <i class="fe" [class]="r.icon"></i>
                  </span>
                  <span class="occ-reason-body">
                    <span class="occ-reason-label">{{ r.label }}</span>
                    <span class="occ-reason-desc">{{ r.description }}</span>
                  </span>
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    } @else if (reason(); as r) {
      <!-- Passo 2: contar o que aconteceu -->
      <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center gap-3 mb-4">
              <span class="occ-reason-icon" [class.occ-reason-icon--sensitive]="r.sensitive">
                <i class="fe" [class]="r.icon"></i>
              </span>
              <div class="flex-grow-1">
                <h2 class="h5 mb-0">{{ r.label }}</h2>
                <span class="text-muted small">{{ r.description }}</span>
              </div>
              <button type="button" class="btn btn-sm btn-white" (click)="clearReason()">{{ fromChannel() ? 'Voltar' : 'Mudar' }}</button>
            </div>

            @if (r.sensitive) {
              <div class="alert alert-info d-flex align-items-start gap-2">
                <i class="fe fe-lock mt-1"></i>
                <span>
                  Esta comunicação segue um circuito reservado: só a tratam as pessoas responsáveis por este tipo
                  de participação.
                  @if (!mustIdentify()) { Pode participar sem se identificar. }
                </span>
              </div>
            }

            <div class="row g-3">
              @if (r.rightsChoice) {
                <div class="col-12">
                  <label class="form-label">Que direito quer exercer?</label>
                  <select class="form-select" formControlName="right">
                    @for (option of rightsOptions; track option.value) {
                      <option [ngValue]="option.value">{{ option.label }}</option>
                    }
                  </select>
                </div>
              }

              @if (r.complaintChoice) {
                <div class="col-12">
                  <label class="form-label">Sobre o que é a reclamação?</label>
                  <select class="form-select" formControlName="complaintReason"
                          (change)="onComplaintReasonChange()">
                    <option [ngValue]="null" disabled>Selecione…</option>
                    @for (option of reasonOptions(); track option.value) {
                      <option [ngValue]="option.value">{{ option.label }}</option>
                    }
                  </select>
                  @if (form.controls.complaintReason.touched && form.controls.complaintReason.invalid) {
                    <small class="text-danger">Escolha o motivo da reclamação.</small>
                  }
                </div>

                @if (complaintReason() === 'OUTRO') {
                  <div class="col-12">
                    <label class="form-label">Qual é o motivo?</label>
                    <input class="form-control" formControlName="complaintReasonOther"
                           placeholder="Diga em poucas palavras sobre o que é a reclamação" />
                    @if (form.controls.complaintReasonOther.touched && form.controls.complaintReasonOther.invalid) {
                      <small class="text-danger">Identifique o motivo da reclamação.</small>
                    }
                  </div>
                }
              }

              @if (r.natureChoice) {
                <div class="col-12">
                  <label class="form-label">Qual a natureza da sua denúncia?</label>
                  <select class="form-select" formControlName="reporterNature" (change)="onNatureChange()">
                    <option [ngValue]="null" disabled>Selecione…</option>
                    @for (option of natureOptions; track option.value) {
                      <option [ngValue]="option.value">{{ option.label }}</option>
                    }
                  </select>
                  @if (form.controls.reporterNature.touched && form.controls.reporterNature.invalid) {
                    <small class="text-danger">Escolha a natureza da denúncia.</small>
                  }
                </div>
                @if (reporterNature() === 'OUTRAS_INFRACOES') {
                  <div class="col-12">
                    <label class="form-label">Especifique a infração ou irregularidade</label>
                    <select class="form-select" formControlName="reporterNatureDetail"
                      (change)="reporterNatureDetail.set(form.controls.reporterNatureDetail.value)">
                      <option [ngValue]="null" disabled>Selecione…</option>
                      @for (option of natureDetailOptions; track option.value) {
                        <option [ngValue]="option.value">{{ option.label }}</option>
                      }
                    </select>
                    @if (form.controls.reporterNatureDetail.touched && form.controls.reporterNatureDetail.invalid) {
                      <small class="text-danger">Especifique a infração ou irregularidade.</small>
                    }
                  </div>
                }
              }

              @if (natureChoices(); as choices) {
                <div class="col-12">
                  <label class="form-label d-block">
                    Natureza do incidente ou violação <span class="text-muted small">(seleção múltipla)</span>
                  </label>
                  <div class="row g-1">
                    @for (option of choices.options; track option.value) {
                      <div class="col-md-6">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [id]="'choice-' + option.value"
                            [class.is-invalid]="categoriesError()"
                            [checked]="isChoiceSelected(option.value)"
                            (change)="toggleChoice(option.value, $any($event.target).checked)"
                          />
                          <label class="form-check-label" [for]="'choice-' + option.value">{{ option.label }}</label>
                        </div>
                      </div>
                    }
                  </div>
                  @if (categoriesError()) { <small class="text-danger">{{ categoriesError() }}</small> }
                </div>
              }

              @if (showOtherText()) {
                <div class="col-12">
                  <label class="form-label">Outra irregularidade: qual?</label>
                  <input class="form-control" formControlName="reportCategoryOther" placeholder="Qual?" />
                  @if (form.controls.reportCategoryOther.touched && form.controls.reportCategoryOther.invalid) {
                    <small class="text-danger">Identifique a outra irregularidade.</small>
                  }
                </div>
              }

              @if (r.categoryChoice) {
                <div class="col-12">
                  <label class="form-label d-block">
                    O que descreve melhor a situação? <span class="text-muted small">(pode escolher mais do que uma)</span>
                  </label>
                  <div class="row g-1">
                    @for (option of categoryOptions(); track option.value) {
                      <div class="col-md-6">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [id]="'cat-' + option.value"
                            [class.is-invalid]="categoriesError()"
                            [checked]="isCategorySelected(option.value)"
                            (change)="toggleCategory(option.value, $any($event.target).checked)"
                          />
                          <label class="form-check-label" [for]="'cat-' + option.value">{{ option.label }}</label>
                        </div>
                      </div>
                    }
                  </div>
                  @if (categoriesError()) { <small class="text-danger">{{ categoriesError() }}</small> }
                </div>
              }

              @if (showHealthDataNote()) {
                <div class="col-12">
                  <div class="alert alert-info mb-0">{{ healthDataNote }}</div>
                </div>
              }

              @if (showReportText()) {
              <div class="col-12">
                <label class="form-label">Assunto</label>
                <input class="form-control" formControlName="title" placeholder="Resuma em poucas palavras" />
                @if (form.controls.title.touched && form.controls.title.invalid) {
                  <small class="text-danger">O assunto é obrigatório.</small>
                }
              </div>

              <div class="col-12">
                <label class="form-label">{{ messageLabel() }}</label>
                <textarea class="form-control" formControlName="message" rows="6"
                  placeholder="Descreva com o detalhe possível: o quê, quando, onde e quem esteve envolvido."></textarea>
                @if (form.controls.message.touched && form.controls.message.invalid) {
                  <small class="text-danger">A mensagem é obrigatória.</small>
                }
              </div>
              }

              <div class="col-12"><hr class="my-1" /></div>

              <div class="col-12">
                @if (mustIdentify()) {
                  <div class="alert alert-warning mb-2">
                    @if (r.nature === 'SUGESTAO_IDEIA') {
                      Nas sugestões e ideias a identificação é obrigatória: precisamos de saber de
                      quem é o contributo para lhe dar seguimento.
                    } @else if (r.scope === 'RGPD' && r.nature === 'DENUNCIA') {
                      Nas comunicações sobre proteção de dados a identificação é obrigatória: o caso
                      tem de se poder relacionar com o titular dos dados.
                    } @else if (r.requiresIdentification) {
                      Para exercer direitos sobre dados pessoais é preciso identificar-se: o pedido só avança
                      depois de confirmarmos que é o titular dos dados.
                    } @else if (isCategorySelected('OUTRA_IRREGULARIDADE')) {
                      Nesta categoria a identificação é obrigatória: sem ela não conseguimos
                      analisar nem dar seguimento à comunicação.
                    } @else {
                      Reclamações sobre produto, serviço, atendimento ou outro motivo têm de ser
                      identificadas para podermos tratá-las e responder-lhe.
                    }
                  </div>
                } @else {
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="identified" formControlName="identified" />
                    <label class="form-check-label" for="identified">Quero identificar-me (deixar e-mail de contacto)</label>
                  </div>
                  @if (natureLocksIdentity()) {
                    <small class="text-muted">
                      @if (reporterNature() === 'PROTECAO_DADOS') {
                        As denúncias sobre dados pessoais exigem identificação.
                      } @else {
                        A opção «Outra irregularidade» exige identificação.
                      }
                    </small>
                  } @else {
                  <small class="text-muted">
                    Sem identificação, a participação é anónima — o acompanhamento faz-se apenas pelo código.
                  </small>
                  }
                }
              </div>

              @if (form.controls.identified.value || mustIdentify() || natureLocksIdentity()) {
                <div class="col-md-6">
                  <label class="form-label">Nome</label>
                  <input class="form-control" formControlName="participantName" placeholder="Como devemos tratá-lo" />
                  @if (form.controls.participantName.touched && form.controls.participantName.invalid) {
                    <small class="text-danger">Indique o nome para participação identificada.</small>
                  }
                </div>
                <div class="col-md-6">
                  <label class="form-label">E-mail</label>
                  <input class="form-control" type="email" formControlName="participantEmail" placeholder="voce@exemplo.com" />
                  @if (form.controls.participantEmail.touched && form.controls.participantEmail.invalid) {
                    <small class="text-danger">Indique o e-mail para participação identificada.</small>
                  }
                </div>
                <div class="col-md-6">
                  <label class="form-label">Telefone <span class="text-muted small">(opcional)</span></label>
                  <input class="form-control" formControlName="participantPhone" />
                </div>
                <div class="col-md-6">
                  <label class="form-label">Relação com a organização <span class="text-muted small">(opcional)</span></label>
                  <select class="form-select" formControlName="participantRelation" (change)="onRelationChange()">
                    <option [ngValue]="null">—</option>
                    @for (option of relationOptions; track option.value) {
                      <option [ngValue]="option.value">{{ option.label }}</option>
                    }
                  </select>
                </div>
                @if (showWorkerType()) {
                  <div class="col-md-6">
                    <label class="form-label">Tipo de colaborador <span class="text-muted small">(opcional)</span></label>
                    <select class="form-select" formControlName="participantWorkerType">
                      <option [ngValue]="null">—</option>
                      @for (option of workerTypeOptions; track option.value) {
                        <option [ngValue]="option.value">{{ option.label }}</option>
                      }
                    </select>
                  </div>
                }
                <div class="col-12">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="participantConfidential"
                           formControlName="participantConfidential" />
                    <label class="form-check-label" for="participantConfidential">
                      Necessidade de reforçar a confidencialidade
                      <span class="text-muted d-block small">
                        Assinale se a sua participação exige cuidados acrescidos no tratamento.
                      </span>
                    </label>
                  </div>
                </div>
              }
            </div>

            @if (serverError()) { <div class="alert alert-danger mt-3">{{ serverError() }}</div> }
          </div>
          <div class="card-footer d-flex justify-content-end">
            <button class="btn btn-primary" [disabled]="loading()">
              {{ loading() ? 'A enviar…' : 'Enviar participação' }}
            </button>
          </div>
        </div>
      </form>
    }
  </div>
</div>
